import { FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import Button from "@/components/buttons/Button.tsx";

import { useGetBroadcastCategories } from "@/hooks/api/broadcast.hooks.ts";
import { cn } from "@/utils/cn.ts";

interface FilterListProps {
  className?: string;
}

const FilterList = ({ className }: FilterListProps): JSX.Element => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: categories } = useGetBroadcastCategories();

  const tvParam = searchParams.get("tv");

  const setParam = (value: number | null): void => {
    const params = new URLSearchParams(searchParams.toString());
    !value ? params.delete("tv") : params.set("tv", value.toString());
    setSearchParams(params);
  };

  return (
    <Swiper
      slidesPerView={"auto"}
      spaceBetween={8}
      breakpoints={{ 1024: { spaceBetween: 10 } }}
      modules={[FreeMode]}
      mousewheel={{ forceToAxis: true }}
      freeMode={true}
      className={className}
    >
      <SwiperSlide className={"w-fit"}>
        <Button
          color={!tvParam ? "orange" : "white"}
          onClick={() => setParam(null)}
          className={cn("w-fit px-5 py-4 font-semibold max-lg:p-3", {
            "hover:text-black-1": tvParam,
          })}
        >
          {t("General.all")}
        </Button>
      </SwiperSlide>
      {categories
        ? categories.map((category) => (
            <SwiperSlide key={category.id} className={"w-fit"}>
              <Button
                color={tvParam === category.id.toString() ? "orange" : "white"}
                onClick={() => setParam(category.id)}
                className={cn("w-fit px-5 py-4 font-semibold max-lg:p-3", {
                  "hover:text-black-1": tvParam !== category.id.toString(),
                })}
              >
                {category.name}
              </Button>
            </SwiperSlide>
          ))
        : null}
    </Swiper>
  );
};

export default FilterList;
